<template lang="pug">
include index.pug
</template>

<script>
export default {
  name: 'OpenOnMobile',
  data: function () {
    return {
      size: 300
    }
  },
  computed: {
    link: function () {
      return window.location.href
    }
  }
}
</script>
